<template>
  <div id="datasetEditors">
    <p class="mb-1"><strong>Dataset Editors</strong><br><small>Grant 'Editor' access to this dataset.</small></p>

    <b-form-checkbox-group
      v-model="datasetEditors"
      :options="editorOptions"
      class="mb-3"
      value-field="id"
      text-field="email"
      @change="updateEditors"
    ></b-form-checkbox-group>

    <div class="float-right">
      <button
        v-if="$store.state.farm.collaboratorData && $store.state.farm.users.length > 0"
        @click="saveEditors()"
        class="btn btn-primary mr-1"
      ><span v-if="saving"><i class="fas fa-sync fa-spin mr-1"></i></span>Save Editors</button>
    </div><!-- /.btn-group -->
  </div><!-- /#datasetEditors -->
</template>

<script>
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      editorOptions: [],
      datasetEditors: [],
      saving: false
    }
  },
  computed: {
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'farm', value: value })
      }
    },
    dataset: {
      get () {
        return this.$store.state.dataset
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'dataset', value: value })
      }
    }
  },
  created () {
    this.gatherEditorOptions()
  },
  methods: {
    updateEditors (e) {
      this.datasetEditors = e
      console.log(this.datasetEditors)
    },
    gatherEditorOptions () {
      this.datasetEditors = this.dataset.editors || []
      this.farm.collaboratorData.forEach(collaborator => {
        const collaboratorId = collaborator.id
        const permissionLevel = this.farm.permissions[collaboratorId]
        if (permissionLevel === 'Permission-only' || permissionLevel === 'Read-only') {
          this.editorOptions.push(collaborator)
        }
      })
    },
    saveEditors () {
      this.saving = true
      fb.datasetsCollection.doc(this.dataset.id).update({
        editors: this.datasetEditors,
        updatedOn: new Date()
      }).then(e => {
        this.dataset.editors = this.datasetEditors
        this.$store.commit('setAlert', { active: true, level: 'alert-success', message: 'Dataset editors saved!', timeout: 3000 })
        this.saving = false
        console.log('Saved')
      }).catch(err => {
        console.log(err)
        this.saving = false
        this.$store.commit('setAlert', { active: true, level: 'alert-warning', message: err.message, timeout: 3000 })
      })
    }
  }
}
</script>
